import React from 'react'
import { Sun, Moon } from 'lucide-react'
import { Header } from '@/components/layout/Header'
import { Card } from '@/components/ui/Card'
import { useThemeStore } from '@/store/themeStore'

export const SettingsPage: React.FC = () => {
  const { isDark, toggleTheme } = useThemeStore()

  return (
    <>
      <Header title="Настройки" />
      <div className="p-6 max-w-2xl">
        <Card padding="lg">
          <h3 className="text-[15px] font-semibold mb-4" style={{ color: 'var(--text-primary)' }}>Внешний вид</h3>
          <div className="flex gap-3">
            <button
              onClick={() => !isDark || toggleTheme()}
              className="flex-1 flex flex-col items-center gap-2 p-4 rounded-xl transition-all"
              style={{
                backgroundColor: !isDark ? 'var(--accent-light)' : 'var(--bg-secondary)',
                border: `2px solid ${!isDark ? 'var(--accent)' : 'var(--border)'}`,
              }}
            >
              <Sun size={24} style={{ color: !isDark ? 'var(--accent)' : 'var(--text-hint)' }} />
              <span className="text-[13px] font-medium" style={{ color: !isDark ? 'var(--accent)' : 'var(--text-secondary)' }}>Светлая</span>
            </button>
            <button
              onClick={() => isDark || toggleTheme()}
              className="flex-1 flex flex-col items-center gap-2 p-4 rounded-xl transition-all"
              style={{
                backgroundColor: isDark ? 'var(--accent-light)' : 'var(--bg-secondary)',
                border: `2px solid ${isDark ? 'var(--accent)' : 'var(--border)'}`,
              }}
            >
              <Moon size={24} style={{ color: isDark ? 'var(--accent)' : 'var(--text-hint)' }} />
              <span className="text-[13px] font-medium" style={{ color: isDark ? 'var(--accent)' : 'var(--text-secondary)' }}>Тёмная</span>
            </button>
          </div>
        </Card>
      </div>
    </>
  )
}
